import storage from 'store'
import expirePlugin from 'store/plugins/expire'
import { systemConfig } from '@/api/login'
import {ACCESS_TOKEN, SYSTEM_CONFIG} from '@/store/mutation-types'

storage.addPlugin(expirePlugin)
const config = {
  state: {
    info: {}
  },

  mutations: {
    SET_INFO: (state, info) => {
      state.info = info
    },
  },

  actions: {
    // 登录
    getSystemConfig({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        systemConfig().then(response => {
          const result = response.data
          commit('SET_INFO', result)
          storage.set(SYSTEM_CONFIG, result)
          return resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default config
